import { render, staticRenderFns } from "./Witnesses.vue?vue&type=template&id=7314acb6&scoped=true"
import script from "./Witnesses.vue?vue&type=script&lang=js"
export * from "./Witnesses.vue?vue&type=script&lang=js"
import style0 from "./Witnesses.vue?vue&type=style&index=0&id=7314acb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7314acb6",
  null
  
)

export default component.exports